import { message } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { getResources } from "../../../../../controller/services/settings";
import i18n from "../../../../../localization/i18n";
import { setLoading } from "../../../../../redux/slices/common_slice";
import RightSideSettingsWrapper from "../../rightside-details-settings/RightSideSettingsWrapper";

const Resources = () => {
  const [resources, setResources] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    getResourcesList();
  }, []);

  const getResourcesList = () => {
    dispatch(setLoading(true));
    getResources()
      .then((resp) => {
        setResources(resp.data.resource);
      })
      .catch((Err) => {
        message.error(Err.message[i18n.language]);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

  const redirect = (link) => {
    window.open(link, "_blank");
  };
  return (
    <>
      <RightSideSettingsWrapper>
        {resources?.map((resource) => (
          <div className="row mx-0 details-common-card-row resources-card" key={resource?._id}>
            <div className="col-12">
              <div className="resources-img-div">
                <img src={resource?.image} alt="" className="img-fluid" />
              </div>
              <div className="resources-details">
                <p>{resource?.description[i18n.language]}</p>
                <Link onClick={() => redirect(resource?.link)}>
                  {resource?.link}
                </Link>
              </div>
            </div>
          </div>
        ))}
      </RightSideSettingsWrapper>
    </>
  );
};

export default Resources;
